package com.milta.core.localization.translations.en

import com.milta.core.localization.AdminUsersStrings

internal val AdminUsers = AdminUsersStrings(
    loading = "Loading…",
    errorNoConnection = "Unable to reach the server — check your connection.",
    errorGeneric = "Something went wrong. Please try again later.",
    readOnlyNotice = "🔒 Read-only — no account can be created, edited, or suspended from this screen yet.",
    kpiAccountsLabel = "Accounts",
    kpiAccountsSubtitle = "all roles combined",
    kpiDriversLabel = "Drivers",
    kpiDriversSubtitle = "without their own team",
    kpiPatronsLabel = "Owners",
    kpiPatronsOrgSingular = "organization",
    kpiPatronsOrgPlural = "organizations",
    kpiActiveSubsLabel = "Active subscriptions",
    kpiActiveSubsSubtitle = "active + grace period",
    kpiAtRiskLabel = "At risk",
    kpiAtRiskSubtitle = "trial or expired",
    searchPlaceholder = "Search by name, email, organization…",
    expandAllAction = "Expand all",
    collapseAllAction = "Collapse all",
    columnAccount = "Account",
    columnContact = "Contact",
    columnType = "Type",
    columnAddedDate = "Added / created on",
    columnSubscription = "Subscription",
    columnSince = "Since",
    columnRenewal = "Renew.",
    noOrganizationHeader = "No organization",
    emptySearchResult = "No account matches this search.",
    patronBadgePrefix = "Owner",
    createdOnPrefix = "Created on",
    emptyTeamMessage = "No driver in this team yet.",
    driverBadge = "Driver",
    addedOnPrefix = "Added on",
    viaOrganization = "Via organization",
    accountCreatedOnUnknown = "Account created on —",
    renewalSingular = "renewal",
    renewalPlural = "renewals",
    subscriptionNone = "None",
    subscriptionActive = "Active",
    subscriptionTrial = "Trial",
    subscriptionGrace = "Grace",
    subscriptionExpiredStatus = "Expired",
    subscriptionCancelled = "Cancelled",
    planOrganization = "Organization",
    planDriver = "Driver",
)
